import { smartFarmSolutionHero } from '@/mocks/smart-farm-solution';

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20stylized%20futuristic%20smart%20farm%20landscape%20with%20orderly%20rows%20of%20lush%20green%20crops%20stretching%20toward%20the%20horizon%20under%20a%20soft%20twilight%20sky%2C%20translucent%20holographic%20data%20panels%20floating%20above%20the%20fields%20showing%20soil%20moisture%20temperature%20and%20crop%20growth%20charts%2C%20glowing%20teal%20network%20lines%20connecting%20IoT%20sensor%20nodes%20and%20a%20hovering%20agricultural%20drone%2C%20deep%20emerald%20and%20teal%20gradient%20atmosphere%20with%20cinematic%20lighting%2C%20editorial%20illustration%20style%2C%20high%20detail&width=1600&height=900&seq=smart-farm-sol-hero-01&orientation=landscape"
          alt="智慧农场解决方案"
          title="智慧农场解决方案"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/92 via-foreground-950/80 to-foreground-950/45"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-transparent to-foreground-950/70"></div>
      </div>

      <div className="absolute -top-20 -left-20 w-72 h-72 md:w-96 md:h-96 rounded-full bg-accent-500/20 blur-3xl animate-float-slow pointer-events-none"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 md:w-[28rem] md:h-[28rem] rounded-full bg-primary-500/15 blur-3xl animate-float-slow pointer-events-none" style={{ animationDelay: '2s' }}></div>

      <div className="relative z-10 w-full px-4 md:px-6 pt-32 pb-20 md:pt-40 md:pb-24 min-h-[680px] md:min-h-[760px] flex items-center">
        <div className="max-w-7xl mx-auto w-full grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="w-full">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/10 border border-background-50/20 backdrop-blur">
              <span className="w-2 h-2 rounded-full bg-accent-400"></span>
              <span className="text-xs md:text-sm text-background-100 tracking-wide whitespace-nowrap">
                {smartFarmSolutionHero.eyebrow}
              </span>
            </div>

            <h1 className="mt-6 font-heading font-bold text-background-50 leading-tight">
              <span className="block text-3xl md:text-5xl">{smartFarmSolutionHero.title}</span>
              <span className="block mt-3 text-3xl md:text-5xl text-accent-300">
                {smartFarmSolutionHero.subtitle}
              </span>
            </h1>

            <p className="mt-6 text-sm md:text-base text-foreground-200 leading-relaxed max-w-xl">
              {smartFarmSolutionHero.desc}
            </p>

            <p className="mt-3 text-sm md:text-base text-foreground-300 leading-relaxed max-w-xl">
              {smartFarmSolutionHero.note}
            </p>

            <div className="mt-8 flex flex-wrap gap-2">
              {smartFarmSolutionHero.tags.map((tag) => (
                <span
                  key={tag}
                  className="px-3 py-1.5 rounded-full text-xs text-background-100 bg-background-50/10 border border-background-50/15 whitespace-nowrap"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="relative w-full">
            <div className="relative rounded-lg overflow-hidden border border-background-50/15">
              <img
                src="https://readdy.ai/api/search-image?query=A%20beautiful%20modern%20smart%20greenhouse%20and%20crop%20field%20scene%20with%20automated%20agricultural%20robots%20and%20connected%20sensor%20devices%2C%20lush%20green%20plants%20growing%20in%20neat%20rows%20under%20soft%20natural%20light%2C%20floating%20translucent%20holographic%20interface%20panels%20showing%20growth%20analytics%2C%20deep%20teal%20and%20emerald%20color%20palette%20with%20warm%20highlights%2C%20clean%20futuristic%20agricultural%20technology%20editorial%20illustration%2C%20high%20detail&width=1000&height=760&seq=smart-farm-sol-hero-visual-02&orientation=landscape"
                alt="智慧农场主视觉"
                title="智慧农场主视觉"
                className="w-full h-[320px] md:h-[440px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent"></div>

              <div className="absolute top-4 left-4 flex flex-col gap-2">
                <div className="px-3 py-2 rounded-md bg-foreground-950/70 backdrop-blur border border-background-50/15">
                  <div className="text-[10px] text-foreground-300 whitespace-nowrap">土壤墒情</div>
                  <div className="text-sm font-semibold text-accent-300 whitespace-nowrap">适宜 · 62%</div>
                </div>
                <div className="px-3 py-2 rounded-md bg-foreground-950/70 backdrop-blur border border-background-50/15">
                  <div className="text-[10px] text-foreground-300 whitespace-nowrap">空气温湿度</div>
                  <div className="text-sm font-semibold text-background-50 whitespace-nowrap">24℃ / 68%</div>
                </div>
              </div>
              <div className="absolute bottom-4 right-4 flex flex-col gap-2 items-end">
                <div className="px-3 py-2 rounded-md bg-foreground-950/70 backdrop-blur border border-background-50/15">
                  <div className="text-[10px] text-foreground-300 whitespace-nowrap">作物状态</div>
                  <div className="text-sm font-semibold text-accent-300 whitespace-nowrap">长势良好</div>
                </div>
                <div className="px-3 py-2 rounded-md bg-foreground-950/70 backdrop-blur border border-background-50/15">
                  <div className="text-[10px] text-foreground-300 whitespace-nowrap">溯源状态</div>
                  <div className="text-sm font-semibold text-background-50 whitespace-nowrap">已上链 · 可查验</div>
                </div>
              </div>
            </div>
            <p className="mt-3 text-right text-[11px] text-foreground-400">
              数据浮层为界面示意，非真实业务数据
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}